import React from 'react';
import moment from 'moment'
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { convertDayShort } from '../../../utils/utils';
import { convertTimeToNewFormat } from '../../common/utils'

import { getCourseLocations } from '../../../actions/commonActions';
const colors = ['#558cbe', '#3ec4c9', '#47a581', '#254369', '#B1B3B4', '#AA3F39', '#FFAEAA'];

export const bgColor = classId => {
  let n = parseInt(classId) % 7;
  return colors[n];
};

const renderDate = (start, end) => {
  if (start && end) {
    const startDate = moment(start).format('MMM D');
    const endDate = moment(end).format('MMM D');
    return `${startDate} - ${endDate}`
  }
  return null
}

const tooltip = course => {
  return (
    <Tooltip id="tooltip">
      <div className="eventTooltipContainer">
        <div className="eventTooltipLine">
          <span style={{ fontWeight: 'bold' }}>{course.longname} ({course.slug})</span>
        </div>
        <div className="eventTooltipLine">
          <span style={{ fontWeight: 'bold' }}>Credits: </span><span>{course.weight}</span>
        </div>
        <div className="eventTooltipLine">
          <span style={{ fontWeight: 'bold' }}>{course.instructor}</span>
        </div>
        {getCourseLocations(course)
          .sort((a, b) => {
            return (a.days[0] || 0) < (b.days[0] || 0) ? -1 : 1
          })
          .map((l, i) => {
           
          return (
            <div key={i} className="location-row">
              <div>
                <span>
                  {l.days.map((m, j) => {
                    return <span key={j}>{convertDayShort(m)},</span>;
                  })}{' '}
                  {convertTimeToNewFormat(l.startTime)} - {convertTimeToNewFormat(l.endTime)} ({renderDate(l.startDate, l.endDate)}{l.location ? ` ${l.location}` : null})
                </span>
              </div>
              
            </div>
          );
        })}
      </div>
    </Tooltip>
  );
};

const Event = ({
  id,
  time,
  longname,
  external_url,
  width,
  height,
  top,
  left,
  isFavoriteClass,
  courses
}) => {
  let s = {
    width: `${width * 100}%`,
    height: `${height * 100}%`,
    top: `${top * 100}%`,
    left: `${left * 100}%`
  };

  let course = courses.find(course => {
    return course.id == id;
  });

  return (
    <div className="eventContainer" style={s}>
      <div className="eventPadding">
        <OverlayTrigger placement="top" overlay={tooltip(course)}>
          <div className="event" style={{ backgroundColor: isFavoriteClass(id) ? '#9b7eaf' : bgColor(id) }}>
            <div className="eventTextWrapper">
              <div className="eventTitle">
                {external_url ? (
                  <a href={external_url} target="_blank">
                    {longname.length > 22 ? longname.substring(0, 20) + '...' : longname}
                  </a>
                ) : longname.length > 22 ? (
                  longname.substring(0, 20) + '...'
                ) : (
                  longname
                )}
              </div>
              <div className="eventLocation">{time}</div>
            </div>
          </div>
        </OverlayTrigger>
      </div>
    </div>
  );
};

export default Event;



// WEBPACK FOOTER //
// ./src/components/common/Calendar/Event.js